export const RESET = 'EXCMTAG_LIST_RESET'
export const SET_ITEMS = 'EXCMTAG_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMTAG_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMTAG_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMTAG_LIST_TOGGLE_LOADING'
